import $ from 'jquery'
import 'slick-carousel'

$(document).ready( initMainSlider )
if (window.acf) {
  window.acf.addAction('render_block_preview/type=slider', initMainSlider)
}

function initMainSlider(){
  if ($('.js-slider').length) {
    $('.js-slider').slick({
      arrows: false,
      dots: true,
      adaptiveHeight: true
    });
  }
}
